'use client';

import styled from 'styled-components';

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  overflow: hidden;
  border-radius: 16px;

  border: 1px solid rgba(0, 0, 0, 0.06);

  /* Premium layered shadow system for authentic depth */
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.04),
    0 4px 12px rgba(0, 0, 0, 0.05),
    0 16px 32px rgba(0, 0, 0, 0.04);

  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Container = styled.div`
  display: flex;
  align-items: flex-end;

  min-width: 260px;
  width: 260px;
  height: 260px;
  margin: 0;
  padding: 8px 0;

  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    cursor: pointer;
    transform: translateY(-4px);

    ${InnerContainer} {
      box-shadow:
        0 2px 4px rgba(0, 0, 0, 0.05),
        0 8px 24px rgba(0, 0, 0, 0.08),
        0 24px 48px rgba(0, 0, 0, 0.06);
      border-color: rgba(0, 0, 0, 0.08);
    }
  }
`;

export const Top = styled.div``;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  gap: 4px;
`;

export const Name = styled.div`
  font-size: 1.3rem;
  font-weight: 600;
  text-align: center;
`;

export const About = styled.div`
  text-align: center;
`;
